import * as types from "../types";

export const getFavouriteEvents = () => ({
  type: types.GET_FAVOURITE_EVENTS,
  request: {
    url: "/favourites",
    method: "GET",
    params: {
      "q[favouritable_type_eq]": "ProgramEvent"
    }
  }
});

export const createFavourite = ({ favouritableId, favouritableType }) => ({
  type: types.CREATE_FAVOURITE,
  request: {
    url: "/favourites",
    method: "POST",
    data: {
      favourite: {
        favouritableId,
        favouritableType
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_SESSION]: ({ data }) => {
        if (favouritableType === "ProgramEvent") {
          return { data: { ...data, programEvent: { ...data.programEvent, isFavourite: true } } };
        }
        if (favouritableType === "Session") {
          return { data: { ...data, isFavourite: true } };
        }
        return { data };
      },
      [types.GET_EPOSTER]: ({ data }) => {
        return { data: { ...data, isFavourite: true } };
      },
      [types.GET_COURSE]: ({ course }) => {
        if (favouritableType === "CourseModule") {
          const courseModules = course.course_modules;
          courseModules.find(module => module.id === favouritableId).is_favourite = true;

          return { course: { ...course, course_modules: courseModules } };
        }
        return { course };
      },
      [types.GET_COURSES]: ({ courses }) => {
        if (favouritableType === "Course") {
          const newCourses = courses;
          newCourses.find(course => course.id === favouritableId).is_favourite = true;

          return { courses: newCourses };
        }

        return { courses };
      }
    }
  }
});

export const deleteFavourite = ({ id }) => ({
  type: types.DELETE_FAVOURITE,
  request: {
    url: `/favourites/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_FAVOURITE_EVENTS]: ({ data }) => {
        return { data: data.filter(fe => fe.id !== id) };
      },
      [types.GET_FAVOURITES]: ({ data }) => {
        return { data: data.filter(f => f.id !== id) };
      }
    }
  }
});

export const getFavourites = () => ({
  type: types.GET_FAVOURITES,
  request: {
    url: "/favourites",
    method: "GET",
    params: {
      "q[favouritable_type_not_eq]": "ProgramEvent"
    }
  }
});
